import { type HTMLAttributes, type Key, type ReactElement } from "react";
import { ListViewType } from "../useListHook";
import Scroll from "components/shared/scroll";

export interface ListViewBlockItem {
  key?: Key;
  field?: string;
  label?: string;
  icon?: string;
  type?: "field" | "action" | "badge";
  onClick?: (props: any) => void;
  render?: (props: any) => ReactElement;
}

export interface ListViewProps extends HTMLAttributes<HTMLDivElement> {
  keyField: Key;
  dataSource?: Record<any, any>[];
  itemComponent: React.FC<{ data: any }>;
  view?: ListViewType;
  scrollerProps?: Record<string, any>;
  listProps?: Record<string, any>;
  itemProps?: Record<string, any>;
  dataTemplate?: number;
  scrollType?: "horizontal" | "vertical";
}

const ListView: React.FC<ListViewProps> = ({
  keyField,
  dataSource,
  itemComponent,
  view,
  scrollerProps,
  listProps,
  itemProps = {},
  dataTemplate,
  scrollType,
  ...rest
}) => {
  const ItemComponent = itemComponent;
  const { className: itemClassName, ...restItemProps } = itemProps;

  const innerContent = (
    <div className="list_view" {...listProps}>
      {dataSource?.map((item) => (
        <div
          className={`item ${itemClassName ?? ""}`}
          key={item[keyField as any]}
          {...restItemProps}
        >
          <ItemComponent data={item} />
        </div>
      ))}
    </div>
  );
  return (
    <div
      className="list_view_container"
      data-scroll=""
      view={view} //NOSONAR
      data-template={dataTemplate}
      {...rest}
    >
      <group className="list_view_scroller" {...scrollerProps}>
        {scrollType ? (
          <Scroll vertical={scrollType === "vertical"}>{innerContent}</Scroll>
        ) : (
          innerContent
        )}
      </group>
    </div>
  );
};

export default ListView;
